import { Box, Flex, useMantineTheme } from "@mantine/core";
import { useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";
import ManageTerms from "src/components/manageTerms";

export const ManageTermsRoute = () => {
    const navigate = useNavigate();
    const _theme = useMantineTheme();

    useEffect(() => {
        if (window.location.hash === "#/manageTerms") navigate({ to: "/manageTerms" });
    }, [navigate]);

    return (
        <Flex p="xl" direction="column" gap="md">
            <Box>
                <ManageTerms />
            </Box>
        </Flex>
    );
};
